import Services from '../services';
import Suppliers from './supplier';

export default {
  name: 'purchase',
  mixins: [Services, Suppliers],
  data() {
    return {
      all_employees: [],
      test: '',
      statusses: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Pending',
          value: 'pending'
        },
        {
          name: 'Partially received',
          value: 'partially'
        },
        {
          name: 'Closed',
          value: 'closed'
        }
      ],
      em_statusses: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Pending',
          value: 'pending'
        },
        {
          name: 'Accepted',
          value: 'accept'
        },
      ],
      types: [
        {
          name: 'All',
          value: ''
        },
        {
          name: 'Coming',
          value: 'coming'
        },
        {
          name: 'Refund',
          value: 'refund'
        }
      ],
      status: {
        name: 'All',
        value: ''
      },
      type: {
        name: 'All',
        value: ''
      },
      purchase_edit_index: -1,
      purchases: [],
      purchase: {
        items: []
      },
      purchases_page: 1,
      purchases_total: 0,
      data_loading: false
    }
  },
  methods: {
    async update_purchases() {
      this.data_loading = true
      const purchases = this.$communicator.then(this, await this.$communicator('purchases', {
        arguments: [10, this.$store.state.purchaseOrder.page],
        params: {
          service: this.store?._id,
          supplier_id: this.supplier?._id,
          status: this.status.value,
          search: this.search,
          type: this.type.value,
          employee_id: this.employee?._id
        }
      }))
      if (purchases) {
        for (let i = 0;i < purchases.data.length;i++) {
          purchases.data[i].state = purchases.data[i].status
          purchases.data[i].status = this.$t(purchases.data[i].status)
          purchases.data[i].total = Math.round(purchases.data[i].total).toLocaleString()
        }
        this.purchases = purchases.data
        this.purchases_total = purchases.page
      }
      this.data_loading = false
    },
    async update_purchase_marks() {
      this.data_loading = true
      var purchases = this.$communicator.then(this, await this.$communicator('purchases', {
        arguments: [10, this.$store.state.purchaseMark.page],
        params: {
          service: this.store._id,
          supplier_id: this.supplier._id,
          status: this.status.value,
          search: this.search,
        }
      }))
      if (purchases) {
        for (let i = 0;i < purchases.data.length;i++) {
          purchases.data[i].state = purchases.data[i].status
          purchases.data[i].status = this.$t(purchases.data[i].status)
          purchases.data[i].total = Math.round(purchases.data[i].total).toLocaleString()
        }
        this.purchases = purchases.data
        this.purchases_total = purchases.page
      }
      this.data_loading = false
    },
    async update_purchase_employees() {
      this.data_loading = true
      const purchases = this.$communicator.then(this, await this.$communicator('purchase_employees', {
        params: {
          limit: 10,
          page: this.$store.state.purchaseOrder.page,
          service: this.store._id,
          status: this.status.value,
          search: this.search,
          employee_id: this.employee._id
        }
      }))
      if (purchases) {
        for (let i = 0;i < purchases.data.length;i++) {
          purchases.data[i].state = purchases.data[i].status
          purchases.data[i].status = this.$t(purchases.data[i].status)
          purchases.data[i].total = Math.round(purchases.data[i].total).toLocaleString()
        }
        this.purchases = purchases.data
        this.purchases_total = purchases.page
      }
      this.data_loading = false
    },
  },
  mounted() {
    this.statusses = [
      {
        name: this.$t('all'),
        value: ''
      },
      {
        name: this.$t('pending'),
        value: 'pending'
      },
      {
        name: this.$t('partially'),
        value: 'partially'
      },
      {
        name: this.$t('closed'),
        value: 'closed'
      }
    ]
    this.em_statusses = [
      {
        name: 'All',
        value: ''
      },
      {
        name: 'Pending',
        value: 'pending'
      },
      {
        name: 'Accepted',
        value: 'accept'
      },
    ]
    this.types = [
      {
        name: 'All',
        value: ''
      },
      {
        name: 'Coming',
        value: 'coming'
      },
      {
        name: 'Refund',
        value: 'refund'
      },
    ]
    // this.status = {
    //   name: this.$t('all'),
    //   value: ''
    // }
    if (!this.access.inv_purchase_mark) {
      this.update_purchases()
    }

  },
  beforeMount() {
    this.access = this.$store.state.access
  }
}
